import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LicenseInfo } from '@mui/x-license';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import { oldVyTheme } from './assets/old-themes/old-vy-theme';
import { DescopeAuthProvider } from './contexts/descope-auth/DescopeAuthProvider';
import { SideBarProvider } from './contexts/side-bar-context/provider/SideBarProvider';
import './index.css';
import { createEmotionCache } from './utils/emotion-cache';
import { isNotProduction } from './utils/env-indicator';
import { client } from './utils/react-query';
import { registerFonts } from './utils/register-fonts';
import { initSentry } from './utils/sentry-config';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);
initSentry();
registerFonts();

// Create Emotion cache with Hotjar-compatible configuration
const emotionCache = createEmotionCache();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <DescopeAuthProvider>
      <CacheProvider value={emotionCache}>
        <QueryClientProvider client={client}>
          <ThemeProvider theme={oldVyTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} dateFormats={{ keyboardDate: 'MM/DD/YYYY' }}>
              <SideBarProvider>
                <App />
              </SideBarProvider>
            </LocalizationProvider>
          </ThemeProvider>
          {isNotProduction() && <ReactQueryDevtools initialIsOpen={false} position="top-left" />}
        </QueryClientProvider>
      </CacheProvider>
    </DescopeAuthProvider>
  </StrictMode>,
);
